// extracted by mini-css-extract-plugin
export default {"framework-selector":"X_ch d-flex","framework-selector__icon":"X_cj","framework-selector__option":"X_ck p-2 flex-grow-1 ml-2","framework-selector__option--selected":"X_cl"};